import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { CommercialCategory } from './pages/CommercialCategory';
import { ProductDetail } from './pages/ProductDetail';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/6m8/commercial-mailboxes-lockers.html" element={<CommercialCategory data-id="element-5" />} data-id="element-4" />
        <Route path="/m8/4C16D-20-D--versatile-4c-depot-16h-20-door-package.html" element={<ProductDetail data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}